import React, { useRef, useState, useEffect, useLayoutEffect } from "react";

export default function MessageBubble(props) {
    const className = props.read ? "" : "unread";
    return (
        <div className={"message-container " + className}>
            <div className="message-icon">
                <img src={props.iconPath} alt="Assistant" />
            </div>
            <div className="message-bubble">
                <div className="message-text" dangerouslySetInnerHTML={{__html: props.message}}>
                </div>
                <div className="message-date">{props.date}</div>
            </div>
            { !props.read && <div className="message-unread"></div> }
        </div>
    );
}